/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneArticleDate as ResolvedStandaloneArticleDate } from 'base/components/standalone/ArticleDate';

export const ArticleDate: typeof ResolvedStandaloneArticleDate = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneArticleDate {...props} />
        </ErrorBoundary>
    );
});

export type ArticleDateProps = PropsFromComponent<typeof ArticleDate>;

/** @deprecated Use slot architecture instead */
export const ArticleDateWith = (extras: DynamicStandaloneExtras): typeof ArticleDate => {
    return function ArticleDate(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ArticleDate');
        return <ResolvedStandaloneArticleDate {...mergeProps({ options: { theme } }, props)} />;
    }
}